"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhitelistType = void 0;
var WhitelistType;
(function (WhitelistType) {
    WhitelistType["FirstRolloutOnboarding"] = "firstRolloutOnboarding";
    WhitelistType["WaiveImplementationFee"] = "waiveImplementationFee";
})(WhitelistType || (exports.WhitelistType = WhitelistType = {}));
